module.exports = __webpack_public_path__ + "static/media/dropdown-gray.6db639e9.svg";